import { Row, Col } from 'react-bootstrap'
import { KnownIssueDto } from 'generated/v1/v1IntegrationsApi'

export interface IPageProps {
    knownIssue: KnownIssueDto
}
const KnownIssueDetails = ({ knownIssue }: IPageProps) => {

    return (
        <Row>
            <Col xs={12}><strong>Issue Description:</strong> </Col>
            <Col xs={12}>{knownIssue.description}</Col>
        </Row>
    )
}
export default KnownIssueDetails